import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useShareChannels } from './hooks/useShareChannels';
import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions({ disableShortLinks }: { disableShortLinks: boolean }) {
	const options = useShareOptions({ disableShortLinks });
	const channels = useShareChannels();

	return useAvailableShareActions(channels, options);
}
